define('views/modules/feedback/blocks/app-rating',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/platform.service',
    // views
    'views/parts/info-section',
    'views/parts/form/sliderbar',
    // templates
    'text!templates/modules/feedback/blocks/app-rating.html'

], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // services
    PlatformService,
    // views
    VInfoSection,
    VSliderbar,
    // templates
    TAppRating
) {

    var VAppRating = Backbone.View.extend({

        template: TAppRating,

        popupInterval: 3,

        regions: {
            appRating: "#feedback-app-rating"
        },

        initialize: function() {
            this.view = {
                info: new VInfoSection({
                    title: "Are you enjoying TotalCoaching?",
                    content: this.template,
                }),
                appRating: new VSliderbar({
                    labels: ["Nope", "A little", "A lot"],
                    color: true,
                    model: this.model,
                    className: 'slider-feedback',
                    attribute: "feedback_app_rating",
                    value: 6
                })
            };

        },

        render: function() {

            this.assign(this.view.info, this.$el)
                .generateZones()
                .assign(this.view.appRating, this.zone.$appRating);

            var options = {
                url: this.model.countUrl(),
            }

            if (PlatformService.isNative()) {
                // Only display the popup at desired interval (exactly once at 3rd feedback)
                $.ajax(options)
                .then(function(itemCount) {
                    if(itemCount === this.popupInterval) {
                        this.toggle(false); // false = show (remove hidden class)
                    }
                }.bind(this));
            }

            return this;
        },

        getValue: function() {
            return this.view.appRating.getValue();
        },

        toggleDisabled: function(val) {
            this.view.appRating.toggleDisabled(val);
            this.$el.toggleClass("disabled", val);
        },

        toggle: function(val) {
            this.$el.toggleClass('hidden', val);
        },

    });

    return VAppRating;

});

